export default "__VITE_ASSET__Bbg9zeqF__"